var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-file-input',_vm._g(_vm._b({class:_vm.designClass,attrs:{"outlined":"","clearable":"","show-size":"","truncate-length":"32","dense":""}},'v-file-input',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }